export const renderDescription = (description: any[]) => {
  return description.map((item, index) => {
    if (typeof item === 'string') {
      return item // Plain text
    } else if (item.type === 'link') {
      return (
        <a key={index} href={item.href}>
          {item.text}
        </a>
      ) // Link
    } else {
      return null
    }
  })
}
